export const monthsConstant = [
    {
        text: "January",
        value: 1
    },
    {
        text: "Febraury",
        value: 2
    },
    {
        text: "March",
        value: 3
    },
    {
        text: "April",
        value: 4
    },
    {
        text: "May",
        value: 5
    },
    {
        text: "June",
        value: 6
    },
    {
        text: "July",
        value: 7
    },
    {
        text: "August",
        value: 8
    },
    {
        text: "September",
        value: 9
    },
    {
        text: "October",
        value: 10
    },
    {
        text: "November",
        value: 11
    },
    {
        text: "December",
        value: 12
    }
];
export const OfficeTypeConstant = [
    {
        value: 0,
        text: 'Main Office'
    },
    {
        value: 1,
        text: 'Branch Office'
    },
    {
        value: 2,
        text: 'Airport'
    },
    {
        value: 3,
        text: 'Branch Office- Border'
    },
    {
        value: 4,
        text: 'Embassy'
    },
    {
        value: 5,
        text: 'Government Institution'
    },
    {
        value: 6,
        text: 'Consulate General'
    },
    {
        value: 7,
        text: 'Permanent Mission'
    },
    {
        value: 8,
        text: 'Honorary Consuls General'
    }
];
export const passportTypes = ['Ordinary', 'Diplomatic', 'Official/Service', 'Laissez-passer','Travel document', 'Crew Passport'];

export const visa_sticker_type = [
    {text: 'Arrival stamp', value: 1},
    {text: 'Visa sticker', value: 2},
    {text: 'Gratis stamp', value: 3}
];
export const apply_type = ['Apply', 'Convert'];
export const condition_type = [{label:'General',value:1},{label:'Custom',value:0}];
export const visa_plans = [
    {text: 'Plain', value: 1},
    {text: 'Single Re-entry', value: 2},
    {text: 'Multiple Re-entry', value: 3}
];
export const tippani_types = ['Trekking', 'Single-Trekking'];
export const STATUS_COLOR = [
    {
        key: 0,
        color: 'grey darken-5'
    },
    {
        key: 1,
        color: 'primary'
    },
    {
        key: 2,
        color: 'green'
    },
    {
        key: 5,
        color: 'orange lighten-1'
    },
    {
        key: 6,
        color: 'orange lighten-1'
    },
    {
        key: 7,
        color: 'orange lighten-1'
    },
    {
        key: 8,
        color: 'orange lighten-1'
    },
    {
        key: 8,
        color: 'orange lighten-1'
    },
    {
        key: 9,
        color: 'orange lighten-1'
    },
    {
        key: 11,
        color: 'purple'
    },
    {
        key: 12,
        color: 'purple'
    },
    {
        key: 13,
        color: 'purple'
    },
    {
        key: 14,
        color: 'purple'
    },
    {
        key: 20,
        color: 'red darken-3'
    },
];
export const STATUS_ICON = [
    {
        key: 0,
        icon: 'mdi-clipboard-text-outline'
    },
    {
        key: 1,
        icon: 'mdi-cash'
    },
    {
        key: 2,
        icon: 'mdi-checkbox-marked-circle'
    },
    {
        key: 5,
        icon: 'mdi-alert-circle'
    },
    {
        key: 6,
        icon: 'mdi-alert-circle'
    },
    {
        key: 7,
        icon: 'mdi-alert-circle'
    },
    {
        key: 8,
        icon: 'mdi-alert-circle'
    },
    {
        key: 8,
        icon: 'mdi-alert-circle'
    },
    {
        key: 9,
        icon: 'mdi-alert-circle'
    },
    {
        key: 11,
        icon: 'mdi-chevron-double-left'
    },
    {
        key: 12,
        icon: 'mdi-chevron-double-right'
    },
    {
        key: 13,
        icon: 'mdi-chevron-double-right'
    },
    {
        key: 14,
        icon: 'mdi-chevron-double-right'
    },
    {
        key: 20,
        icon: 'mdi-cancel'
    },
];

export const STATUS_COLOR_MAP = {
    'Applied': 'primary',
    'Applied for extend': 'blue',
    'Applied for conversion': 'blue darken-3',
    'Approved': 'green',
    'Verified': 'green darken-3',
    'Extend Approved': 'green darken-2',
    'Convert Approved': 'green darken-2',
    'Paid': 'yellow darken-3',
};

export function mapStatusNameColor(statusName){
    return STATUS_COLOR_MAP[statusName] || 'red';
}